import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout/Layout';
import Profile from './pages/Profile/Profile';
import RecruiterPending from './components/Recruiter/RecruiterPending';
import RecruiterRejected from './components/Recruiter/RecruiterRejected';
import ForRecruiters from './pages/ForRecruiters';

// Pages
import Home from './pages/Home';
import Jobs from './pages/Jobs';
import Blog from './pages/Blog';
import CVCreator from './pages/CVCreator';
import CoverLetter from './pages/CoverLetter';
import Admin from './pages/Admin';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Disclaimer from './pages/Disclaimer';
import Paia from './pages/Paia';
import CookiePolicy from './pages/CookiePolicy';
import PopiaNotice from './pages/PopiaNotice';
import RecruiterTerms from './pages/RecruiterTerms';
import CandidateTerms from './pages/CandidateTerms';
import CareerSuccess from './pages/CareerSuccess';
import AcademicSuccess from './pages/AcademicSuccess';
import SupportUs from './pages/SupportUs';
import RecruiterDashboard from './pages/RecruiterDashboard';

function App() {
    return (
        <Router>
            <AuthProvider>
                <Layout>
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/jobs" element={<Jobs />} />
                        <Route path="/blog" element={<Blog />} />
                        <Route path="/cv-creator" element={<CVCreator />} />
                        <Route path="/cover-letter" element={<CoverLetter />} />
                        <Route path="/admin" element={<Admin />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/privacy" element={<Privacy />} />
                        <Route path="/terms" element={<Terms />} />
                        <Route path="/disclaimer" element={<Disclaimer />} />
                        <Route path="/paia" element={<Paia />} />
                        {/* ADD THESE MISSING ROUTES */}
                        <Route path="/cookie-policy" element={<CookiePolicy />} />
                        <Route path="/popia-notice" element={<PopiaNotice />} />
                        <Route path="/recruiter-terms" element={<RecruiterTerms />} />
                        <Route path="/candidate-terms" element={<CandidateTerms />} />
                        <Route path="/recruiter-pending" element={<RecruiterPending />} />
                        <Route path="/recruiter-rejected" element={<RecruiterRejected />} />
                        <Route path="/for-recruiters" element={<ForRecruiters />} />
                        <Route path="/profile" element={<Profile />} />
                        <Route path="/career-success" element={<CareerSuccess />} />
                        <Route path="/academic-success" element={<AcademicSuccess />} />
                        <Route path="/support-us" element={<SupportUs />} />
                        <Route path="/recruiter-dashboard" element={<RecruiterDashboard />} />
                    </Routes>
                </Layout>
            </AuthProvider>
        </Router>
    );
}

export default App;